var debounce = require('debounce');

window.addEventListener('resize', debounce(calculate_correct_vh, 50));
calculate_correct_vh();

function calculate_correct_vh() {
  //Add a custom CSS variable which represents the true vertical height (with safari nav bar considered)
  document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
}